import React, { Component } from "react";
import NavControlsGenerator from "../utilities/NavControlsGenerator";

class TimeToPrepareQuote extends Component {
  componentDidMount() {
  }
  render() {
    return (
      <section className="sectionContent"><div className="page">
        <header>
          <h2>Time to prepare quote</h2>
        </header>
        <div className="pageContent"></div>
        <NavControlsGenerator currentPageNavCode={40}></NavControlsGenerator>
      </div></section>
    );
  }
}

export default TimeToPrepareQuote;
